<doc>
  @desc:   布局 - 头部组件
  @author:  
</doc>
<template>
  <div :class="['header-layout', 'header-sticky', headerLayoutStyle(), {'noNav': noNavStyle()}]">
    <div :class="['header-wrapper', headerStyle(), isScoll?'header-bg':'']">
      <div class="header-content flex flex-align-center" :class="!popSetting ? 'hidden' : ''">
        <div class="header-logo" @click="goHome()">
          <span class="header-logo-img"></span>
          <p class="header-logo-txt" v-if="false">Focus on soccer data and algorithms</p>
        </div>

        <Navbar :navTab="navTab" />

        <!-- <div class="header-search flex flex-align-center">
          <i class="icon-font icon-search"></i>
          <span>Search</span>
        </div> -->
        
        <div class="login-wrapper flex flex-align-center" v-if="policy">
          <div class="login-info flex flex-align-center" v-if="loginInfoShow" @click="accountClick()">
            <i><img  :src="login.avatar == '' ? require(`@/assets/images/avtar.png`) : login.avatar"/></i>
            <el-tooltip effect="dark" :content="login.nickname" placement="bottom-end">
              <span>{{ common.displayedString(login.nickname, 5) }}</span>
            </el-tooltip>
          </div>
          <div class="login-btn" @click="showLoginPopup" v-if="!loginInfoShow">{{ langConfig.login[langConfig.curLang]['LOGIN'] }}</div>
          <div class="set-wrapper" :class="popSetting ? 't-seti-show' : ''" @click="setBtn()" ref="setMain" v-if="isSetShowFn()">
            <i class="icon-seti"></i>
          </div>
        </div>

        <div class="pop-setting-wrapper" :class="popSetting ? 'pop-setting-show' : ''" ref="popSetMain" v-if="policy" @click.self="bodyClose()">
          <div class="popNav flex flex-align-center" v-show="screenWidth<= 767">
            <template v-for="(item, index) in langConfig.txtLang[langConfig.curLang]['POP_NAV']">
              <span :class="tab==item.id ? 'on' : ''" @click="tabClick(item.id)" :key="index">{{ item.name }}</span>
            </template>
          </div>
          <div class="setting-menu-contant flex flex-v" v-show="screenWidth > 767 || tab == 1">
            <div class="setting-account flex flex-v" v-if="false">
              <button class="setting-account-btn" @click="accountClick()">{{ langConfig.account[langConfig.curLang]['ACCOUNT_INFO'] }}</button>
            </div>

            <div class="setting-account flex flex-v">
              <button class="setting-account-btn" @click="myLeagueClick()">{{ langConfig.txtLang[langConfig.curLang]['MY_LEAGUES'] }}</button>
            </div>

            <!-- <div class="setting-mode flex flex-v">
              <div class="setting-mode-title flex flex-align-center">
                <i class="icon-dark"></i>
                <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['DARK_MODE'] }}</span>
                <div class="switch-box">
                  <el-switch
                    :active-value="true"
                    :inactive-value="false"
                    v-model="setting.darkSwith"
                    :width="30"
                    @change="(val) => {
                      changeTheme(val)
                    }"
                    >
                  </el-switch>
                </div>
              </div>
            </div> -->
            <!-- <div class="setting-mode flex flex-v">
              <div class="setting-mode-title flex flex-align-center">
                <i class="icon-font icon-sound"></i>
                <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['SOUND'] }}</span>
                <div class="switch-box">
                  <el-switch
                    v-model="setting.soundSwith"
                    active-color="#09B363"
                    inactive-color="#D9D9D9">
                  </el-switch>
                </div>
              </div>
            </div> -->
            <div class="setting-mode flex flex-v" v-show="isSetModle('timeZone')">
              <div class="setting-mode-title flex flex-align-center">
                <i class="icon-time"></i>
                <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['TIME_ZONE'] }}</span>
              </div>
              <div class="setting-mode-content flex flex-v">
                <div class="pickerPlug"> 
                  <DasePicker class="dasePickerBox" 
                    ref="DasePicker"
                    :options="pickerList"  
                    @changePicker="changePicker"
                  ></DasePicker>
                </div> 
              </div>
            </div>
            <div class="setting-mode flex flex-v" v-if="isSetModle('oddsForm')">
              <div class="setting-mode-title flex flex-align-center">
                <i class="icon-type"></i>
                <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['ODDS_FORMAT'] }}</span>
              </div>
              <div class="setting-mode-content">
                <div class="setting-odds-form">
                  <el-radio-group v-model="setting.oddsFormRadio" @change="(val) => {
                  onChangeSetting(val, 'oddsFormRadio')
                }">
                    <el-radio class="sort-radio" :label="1">EU(1.50)</el-radio>
                    <el-radio class="sort-radio" :label="2">UK(1/2)</el-radio>
                    <el-radio class="sort-radio" :label="3">HK(0.50)</el-radio>
                    <el-radio class="sort-radio" :label="4">MA(0.50)</el-radio>
                    <el-radio class="sort-radio" :label="5">US(-200)</el-radio>
                    <el-radio class="sort-radio" :label="6">IN(-2.00)</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="setting-mode flex flex-v" v-if="false">
              <div class="setting-mode-title flex flex-align-center">
                <i class="icon-font icon-exit"></i>
                <span class="mode-text"><a class="out-login" @click="logout">{{ langConfig.login[langConfig.curLang]['LOGOUT'] }}</a></span>
              </div>
            </div>
          </div>

          <div class="pop-league-contant" v-show="screenWidth<= 767 && tab == 0">
            <MyLeague :myLeague="myLeague" @onLeagueFollowChange="onLeagueFollowChange" />
            <!-- <HotLeague :hotLeague="hotLeague" :myLeague="myLeague" /> -->
          </div>
        </div>
        <div class="pop-setting-mask" v-show="popSetting"></div>
      </div>
      
      <van-popup v-model="accountShow" class="van-popup-m"
      closeable
      close-icon="close"
      :position="screenWidth>767?'center':'bottom'" get-container="#app">
        <div class="account-pop-wrapper flex flex-v" v-if="accountShow">
          <h3 class="account-title">{{ langConfig.account[langConfig.curLang]['ACCOUNT_INFO'] }}</h3>
          <div class="account-box flex flex-v">
              <div class="account-item">
                <div class="accout-text">Profile Picture:</div>
                <div class="accout-input">
                  <div class="account-avtar">
                    <van-uploader
                      :before-read="beforeRead"
                      :max-count="1"
                      :deletable="false"
                      :preview-full-image="false"
                    >
                    <img :src="account.avatar" />
                    </van-uploader>
                  </div>
                  <div class="avtar-tips">Please upload an image smaller than 1MB.</div>
                </div>
              </div>
              <div class="account-item mt10">
                <div class="accout-text">Nickname:</div>
                <div class="accout-input">
                  <div class="account-name">
                    <van-field
                      :value="account.nickname"
                      name="nickname"
                      @input="nickNameChage"
                    />
                  </div>
                  <div class="account-form-btn">
                    <van-button :disabled="isEdit" round block type="info" native-type="submit" @click.stop="onForgotInfoSubmit">
                      <span>{{ langConfig.login[langConfig.curLang]['SAVE'] }}</span>
                    </van-button>
                  </div>
                </div>
              </div>
          </div>
          <div class="account-form flex flex-v" v-if="login.loginType == 4">
            <van-form ref="form" @submit="onForgotPwdSubmit">
              <div class="account-form-item mt16 flex">
                <div class="account-form-text">{{ langConfig.account[langConfig.curLang]['EMAIL'] }}:</div>
                <div class="account-form-input"><span>{{ login.email }}</span></div>
              </div>
              <div class="account-form-item flex">
                <div class="account-form-text"><span>{{ langConfig.account[langConfig.curLang]['OLD_PASSWORD'] }}:</span></div>
                <div class="account-form-input">
                  <van-field
                    v-model="account.password1"
                    name="password1"
                    :placeholder="langConfig.account[langConfig.curLang]['PLACEHOLDER_PWD1']"
                    :right-icon="account.passwordState1 ? 'eye' : 'closed-eye'"
                    :type="!account.passwordState1 ? 'password' : 'text'"
                    @click-right-icon="account.passwordState1 = !account.passwordState1"
                    :error-message="account.errorMessagePwd1"
                    @input="validatroFn(account.password1, 'pwd1')"
                  />
                </div>
              </div>
              <div class="account-form-item flex">
                <div class="account-form-text"><span>{{ langConfig.account[langConfig.curLang]['NEW_PASSWORD'] }}:</span></div>
                <div class="account-form-input">
                  <van-field
                    v-model="account.password2"
                    name="password2"
                    :placeholder="langConfig.account[langConfig.curLang]['PLACEHOLDER_PWD2']"
                    :right-icon="account.passwordState2 ? 'eye' : 'closed-eye'"
                    :type="!account.passwordState2 ? 'password' : 'text'"
                    @click-right-icon="account.passwordState2 = !account.passwordState2"
                    :error-message="account.errorMessagePwd2"
                    @input="validatroFn(account.password2, 'pwd2')"
                  />
                </div>
              </div>
              <div class="account-form-item flex">
                <div class="account-form-text"><span>{{ langConfig.account[langConfig.curLang]['CONFIRM_PASSWORD'] }}:</span></div>
                <div class="account-form-input">
                  <van-field
                    v-model="account.password3"
                    name="password3"
                    :placeholder="langConfig.account[langConfig.curLang]['PLACEHOLDER_PWD3']"
                    :right-icon="account.passwordState3 ? 'eye' : 'closed-eye'"
                    :type="!account.passwordState3 ? 'password' : 'text'"
                    @click-right-icon="account.passwordState3 = !account.passwordState3"
                    :error-message="account.errorMessagePwd3"
                    @input="validatroFn(account.password3, 'pwd3')"
                  />
                </div>
              </div>
              <div class="account-form-btn">
                <van-button :disabled="account.disabled" round block type="info" native-type="submit">
                  <span>{{ langConfig.login[langConfig.curLang]['SAVE'] }}</span>
                </van-button>
              </div>
            </van-form>
          </div>
          <div class="account-auth">
            <div class="account-auth-form flex flex-v">
              <h3 class="account-auth-title">{{ langConfig.account[langConfig.curLang]['AUTH_INFO'] }}</h3>
              <div class="account-form-item flex">
                <div class="account-form-text flex flex-align-center">
                  <i><img src="~@/assets/images/google-icon.svg" /></i>
                  <span>Google</span>
                </div>
                <div class="account-form-input">
                  <div class="account-auth-btn" :class="login.userInfoOAuth.googleToken ? ' account-auth-btn-disable' : ''">
                    <van-button :disabled="login.userInfoOAuth.googleToken" round block type="info" @click="loginWithGoogle()">
                      <span>{{ login.userInfoOAuth.googleToken ? langConfig.account[langConfig.curLang]['BOUND'] : langConfig.account[langConfig.curLang]['BIND_NOW'] }}</span>
                    </van-button>
                  </div>
                </div>
              </div>
              <div class="account-form-item flex">
                <div class="account-form-text flex flex-align-center">
                  <i><img src="~@/assets/images/tiktok-icon.svg" /></i>
                  <span>Tiktok</span>
                </div>
                <div class="account-form-input">
                  <div class="account-auth-btn" :class="login.userInfoOAuth.tiktokToken ? ' account-auth-btn-disable' : ''">
                    <van-button :disabled="login.userInfoOAuth.tiktokToken" round block type="info" @click="common.loginWithTiktok()">
                      <span>{{ login.userInfoOAuth.tiktokToken ? langConfig.account[langConfig.curLang]['BOUND'] : langConfig.account[langConfig.curLang]['BIND_NOW'] }}</span>
                    </van-button>
                  </div>
                </div>
              </div>
              <!-- <div class="account-form-item flex">
                <div class="account-form-text flex flex-align-center">
                  <i><img src="~@/assets/images/face-icon.svg" /></i>
                  <span>Facebook</span>
                </div>
                <div class="account-form-input">
                  <div class="account-auth-btn" :class="login.userInfoOAuth.facebookToken ? ' account-auth-btn-disable' : ''">
                    <van-button :disabled="login.userInfoOAuth.facebookToken" round block type="info">
                      <span>{{ login.userInfoOAuth.facebookToken ? langConfig.account[langConfig.curLang]['BOUND'] : langConfig.account[langConfig.curLang]['BIND_NOW'] }}</span>
                    </van-button>
                  </div>
                </div>
              </div> -->
              <!-- <div class="account-form-item flex">
                <div class="account-form-text flex flex-align-center">
                  <i><img src="~@/assets/images/apple-icon.svg" /></i>
                  <span>Apple</span>
                </div>
                <div class="account-form-input">
                  <div class="account-auth-btn" :class="login.userInfoOAuth.appleToken ? ' account-auth-btn-disable' : ''">
                    <van-button :disabled="login.userInfoOAuth.appleToken" round block type="info" @click="loginWithApple()">
                      <span>{{ login.userInfoOAuth.appleToken ? langConfig.account[langConfig.curLang]['BOUND'] : langConfig.account[langConfig.curLang]['BIND_NOW'] }}</span>
                    </van-button>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <div class="accout-logout-box" @click="logout()">Log Out</div>
        </div>

        <div class="guide-wrapper" @click="wxShow=false" v-if="wxShow">
          <div class="guider-arr"><img src="~@/assets/images/guide-arr.svg" /></div>
          <div class="guider-txt">Please open and log in using your browser</div>
          <ul class="guider-list">
            <li><i></i><p>Click the "..." button in the top right corner</p></li>
            <li><i></i><p>Select "Open in Browser"</p></li>
          </ul>
        </div>
      </van-popup>

      <van-popup v-model="myLeagueShow" class="van-popup-m"
      :duration="0.2"
      closeable
      close-icon="close"
      position="center" get-container="#app" v-if="screenWidth>767">
        <MyLeague :myLeague="myLeague" @onLeagueFollowChange="onLeagueFollowChange" />
      </van-popup>
      <Login :loginShow="loginShow"  @onChangePop="onChangePop" />
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { getResetPassword, getAvatarUpload, getAvatarEdit } from '@/api/api';

  import DasePicker from '@/components/basePicker.vue';
  import Navbar from '@/components/navbar.vue';
  import Login from '@/components/login.vue';
  import MyLeague from '@/components/myLeague.vue';
  import HotLeague from '@/components/hotLeague.vue';

  export default {
    components: {
      DasePicker,
      Navbar,
      Login,
      MyLeague,
      HotLeague,
    },

    props:{
      setShow:{
        type:Array,
        default:() =>[],
      },
      tsz: {
        type: Number,
        default:0
      },
      navTab: {
        type: Number,
        default: 0
      },
      isLogin: {
        type: Boolean,
        default: false
      },
      policy: {
        type: Boolean,
        default: true
      },
      myLeague: {
        type: Object,
        default: () => {},
      },
      pageType: {
        type: String,
        default: () => ''        
      }
    },

    data() {
      return {
        isScoll: false,
        tab: 1,
        oddTypeArr: ['1x2', 'AH', 'O/U'],
        myLeagueShow: false,
        accountShow: false,
        loginInfoShow: false,
        loginShow: false,
        popSetting: false,
        isSetShow: true,
        isSubmitting: false,
        login: {
          nickname: '',
          uid: 0,
          avatar: '',
          token: '',
          email: '',
          userInfoOAuth: {},
          loginType: ''
        },
        setting: {
          darkSwith: false,
          soundSwith: true,
          sortRadio: 1,
          oddsType: 1,
          oddsFormRadio: 1,
          tsz: '+08:00',
        },
        svrTimestamp: 0,
        tszArr: ['-12:00','-11:00','-10:00','-09:00','-08:00','-07:00','-06:00','-05:00','-04:30','-04:00','-03:30','-03:00','-02:00','-01:00','00:00','+01:00','+02:00','+03:00','+03:30','+04:00','+05:00','+05:30','+05:45','+06:00','+06:30','+07:00','+08:00','+09:00','+10:00','+10:30','+12:00'],
        pickerList:[{
            value: '+08:00',
            name: '11/13, 22:00, GMT+08:00'
          }],
        pickerIndex: 0,
        proceessTime: null, // 服务器时间定时器
        proceessNum: false,

        screenWidth:2000,

        account: {
          disabled: true,  // 提交是否禁用
          password1: '',
          password2: '',
          password3: '',
          errorMessagePwd1: '',
          errorMessagePwd2: '',
          errorMessagePwd3: '',
          passwordState1: false,
          passwordState2: false,
          passwordState3: false,
          pwdRxp: /[a-zA-Z0-9]{6,}/,
          nickname: '',
          avatar: '',
        },
        isEdit: true, // 修改昵称提交是否禁用
        isUpload: false,

        wxShow: false,
      }
    },
    mounted(){
      if(typeof(window) != 'undefined'){
        this.screenWidth = window.innerWidth;
        this.userInfo();
        this.setCookieSetting();
        document.addEventListener('click', this.bodyClose);
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll, false);
      }
    },
    methods: {
      goHome(){
        this.$router.push('/');
      },

      // tab
      tabClick(val){
        let _val = val, _tab = this.common.jsonParse(this.tab);
        if(_val == _tab){
          return;
        }
        
        this.tab = _val;
      },

      // 设置按钮显示隐藏
      isSetShowFn(){
        let _setShow = this.setShow;
        if(_setShow.length > 0){
          if(_setShow.includes('news')){
            if(this.loginInfoShow){
              return true;
            }else{
              return false;
            }
          }
          return true
        }else{
          return false
        }
      },

      // 设置模块显示隐藏
      isSetModle(type){ // 时区-'timeZone', 排序-'order', 指数类型-'oddsType', 赔率格式-'oddsForm'
        let _type = type, _setShow = this.setShow;
        if(_setShow.indexOf(_type)>-1){
          return true;
        }
        return false;
      },
      // 设置弹窗
      setBtn(){
        if(!this.proceessNum){
          this.process_svrTime();
        }

        if(!this.popSetting){
          this.tzPickerArr();
          this.$nextTick(() => { // 下拉定位
            let _setting = this.common.getCookie('setting');

            if(typeof(_setting) != 'undefined' && _setting != null){
              _setting = JSON.parse(_setting);
              this.setting.tsz = _setting.tsz;
              
            }

            let _pickerList = this.common.jsonParse(this.pickerList);
            for(let item in _pickerList){
              if(_pickerList[item].value == this.setting.tsz){
                this.pickerIndex = item;
              }
            }

            this.$refs.DasePicker?.setValue(this.pickerIndex);
          });
          this.popSetting = true;
        }else{
          this.$refs.DasePicker?.closePicker();
          this.popSetting = false;
        }
        
      },

      // 时区下拉发生改变时
      changePicker(val){ 
        let _tsz = val.value, _setting = this.setting;
        _setting.tsz = _tsz;

        this.pickerIndex = val.index;

        this.common.setCookie('setting', JSON.stringify(_setting));

        if(this.$listeners.onChangeSetting){
          this.$emit('onChangeSetting',_setting);
        }
      }, 

      // 时区列表
      tzPickerArr(){
        let _arr = [], _tsz = this.tszArr;
        for(let i=0; i<_tsz.length; i++){
          let _tztime = this.common.getDateByArray(_tsz[i], this.svrTimestamp)
          let _date = this.common.dateStr(_tztime, 'MM/dd');
          let _time = this.common.dateStr(_tztime, 'HH:mm');
          _arr.push({
            value: _tsz[i],
            name: _date + ', '+ _time +', GMT' + _tsz[i]
          });
        }
        this.pickerList = _arr;
      },

      // 更新服务器时间
      process_svrTime: function () {
        if(this.proceessNum){
          this.svrTimestamp += 60;
        }else{
          this.proceessNum = true;
        }

        if (typeof(this.proceessTime) == "number"){
          clearTimeout(this.proceessTime);
        }
        this.proceessTime = setTimeout(this.process_svrTime, 60000);
      },

      // 设置操作
      onChangeSetting(val, type) {
        let _setting = this.setting;

        _setting[type] = val;

        this.common.setCookie('setting', JSON.stringify(_setting));

        if(this.$listeners.onChangeSetting){
          this.$emit('onChangeSetting',_setting);
        }

        if(type == 'oddsFormRadio'){
          this.$emit('onChangeOddsFrom', val);
        }
        
      },

      // 登录弹窗
      showLoginPopup() {
        if(!this.loginShow){
          let eventName = 'LS_PC_H_Login';
          if(this.common.isMobile != 4){
              eventName = 'LS_Webapp_H_Login';
          }

          this.common.googleEvent(eventName, {
              '触发位置': '顶部栏右侧登录按钮'
          });
        }

        this.loginShow = true;
      },

      // 登录传参
      onChangePop(val) {
        let _val = val;
        this.loginShow = _val.loginShow;
        this.loginInfoShow = _val.loginInfoShow;
        this.$emit('onChangLogin', _val);
        if(this.loginInfoShow){
          this.userInfo();
        }
      },

      // 关注赛事变化回调
      onLeagueFollowChange(val){
        if(val){
          //this.myLeague = val;
          if(this.$listeners.onLeagueFollowChange){
            this.$emit('onLeagueFollowChange', val);
          }
        }
      },

      // 用户信息
      userInfo() {
        let _userInfo = this.common.getCookie('userInfo');
        //console.log('userInfo', _userInfo)
        
        if(typeof(_userInfo) == 'undefined' || _userInfo == null){
          //console.log('no userinfo')
          return;
        }
        _userInfo = JSON.parse(_userInfo);
        _userInfo.nickname = this.common.getUserName(_userInfo.nickname);
        this.loginInfoShow = true;
        this.account.nickname = this.login.nickname = _userInfo.nickname;
        this.login.uid = _userInfo.uid;
        this.login.token = _userInfo.token;
        this.login.email = _userInfo.email;
        this.login.avatar = _userInfo.avatar || '';
        this.login.userInfoOAuth = _userInfo.userInfoOAuth || {};
        this.login.loginType = _userInfo.loginType;

        let _avatar = require(`@/assets/images/avtar.png`);
        if(this.login.avatar != ''){
          _avatar = this.login.avatar
        }
        this.account.avatar = _avatar;
      },

      // 退出登录
      logout() {
        this.accountShow = false;
        this.loginInfoShow = false;
        this.account.nickname = this.login.nickname = '';
        this.login.uid = 0;
        this.login.token = '';
        this.common.delCookie('userInfo');
        location.reload();
      },

      // cookies设置
      setCookieSetting() {
        let _setting = this.common.getCookie('setting');

        if(typeof(_setting) != 'undefined' && _setting != null){
          _setting = JSON.parse(_setting);
          this.setting.darkSwith = _setting.darkSwith;
          this.setting.soundSwith = _setting.soundSwith;
          this.setting.sortRadio = _setting.sortRadio*1;
          this.setting.oddsType = _setting.oddsType*1;
          this.setting.oddsFormRadio = _setting.oddsFormRadio*1;
          this.setting.tsz = _setting.tsz;
        }
      },

      bodyClose(e) {
        if (this.$refs.setMain && !this.$refs.setMain.contains(e.target) && this.$refs.popSetMain && !this.$refs.popSetMain.contains(e.target)) {
          if (this.popSetting){
            this.$refs.DasePicker?.closePicker();
            this.popSetting = false;
          }
        }
      },

      //获取屏幕宽度
      handleResize() {
        if(typeof window!='undefined'){
          this.screenWidth = window.innerWidth;
        }
      },

      // 我的关注按钮
      myLeagueClick() {
        if(this.myLeagueShow){
          this.myLeagueShow = false;
        }else{
          this.myLeagueShow = true;
        }

        this.popSetting = false;
      },

      // 用户信息按钮
      accountClick() {
        if(this.accountShow){
          this.accountShow = false;
        }else{
          this.accountShow = true;
          setTimeout(() => {
            this.clearInput();
          }, 50);
        }

        this.popSetting = false;
      },

      // 修改用户信息
      onForgotInfoSubmit(e){
        // 阻止冒泡，防止输入框失去焦点
        this.isSubmitting = true;
        let param = {
          images: this.account.avatar,
          nickname: this.account.nickname,
          userToken: this.login.token
        }

        this.isEdit = false;
        getAvatarEdit(param).then((res) => {
          let _res = res;
          if(_res.state == 200){
            Toast({
              message: this.langConfig.account[this.langConfig.curLang]['EDIT_SUCCESS'],
              duration: 1000,
              onClose: () => {
                this.isSubmitting = false;
                this.accountShow = false;
                this.isEdit = true;
                
                this.login.avatar = this.account.avatar;
                this.login.nickname = this.account.nickname;
                this.common.setCookie('userInfo', JSON.stringify(this.login));
              }
            })
          }else{
            Toast(_res.msg);
          }
          
        }).catch((res) => {
          console.error(res)
        })
      },

      // 用户信息修改密码
      onForgotPwdSubmit(){
        let param = {
          original_password: this.account.password1,
          password: this.account.password3,
          userToken: this.login.token
        }
        
        getResetPassword(param).then((res) => {
          this.account.disabled = false;
          let _res = res;
          if(_res.state == 200){
            Toast({
              message: this.langConfig.account[this.langConfig.curLang]['RESET_SUCCESS'],
              duration: 1000,
              onClose: () => {
                this.accountShow = false;
              }
            })
          }else{
            Toast(_res.msg);
          }
          
        }).catch((res) => {
          console.error(res)
        })
      },

      // 提交按钮是否可用
      isSubmit(){

        if(this.account.password1 != '' && this.account.password2 != '' && this.account.password3 != '' && (this.account.password2 === this.account.password3) && this.account.errorMessagePwd1 == '' && this.account.errorMessagePwd2 == '' && this.account.errorMessagePwd3 == ''){
            this.account.disabled = false;
          }else{
            this.account.disabled = true;
          }
          return;
      },

      // 清空输入框
      clearInput(){
        this.account.errorMessagePwd1 = '';
        this.account.errorMessagePwd2 = '';
        this.account.errorMessagePwd3 = '';
        this.account.password1 = '';
        this.account.password2 = '';
        this.account.password3 = '';
        this.account.passwordState1 = false;
        this.account.passwordState2 = false;
        this.account.passwordState3 = false;
        this.account.avatar = this.login.avatar;
        this.account.nickname = this.login.nickname;
        this.account.disabled = true;
        this.isEdit = true;
        this.$refs.form.resetValidation();
      },

      // 输入框验证
      validatroFn(val, type){
        let _reg = this.account.pwdRxp;
        if(type == 'pwd1') {
          if(_reg.test(val)){
            this.account.errorMessagePwd1 = '';
            this.account.password1 = val;
            this.isSubmit();
            return true;
          }else{
            this.account.errorMessagePwd1 = this.langConfig.login[this.langConfig.curLang]['LEAST_DIGITS'];
            this.isSubmit();
            return false;
          }
        }else if(type == 'pwd2') {
          if(_reg.test(val)){
            this.account.errorMessagePwd2 = '';
            this.account.password2 = val;
            this.isSubmit();
            return true;
          }else{
            this.account.errorMessagePwd2 = this.langConfig.login[this.langConfig.curLang]['LEAST_DIGITS'];
            this.isSubmit();
            return false;
          }
        }else if(type == 'pwd3') {
          if(_reg.test(val)){
            this.account.errorMessagePwd3 = '';
            this.account.password3 = val;
            if(this.account.password2 === this.account.password3){
              this.isSubmit();
            }else{
              this.account.errorMessagePwd3 = this.langConfig.login[this.langConfig.curLang]['INCONSISTENT'];
              this.isSubmit();
            }
            return true;
          }else{
            this.account.errorMessagePwd3 = this.langConfig.login[this.langConfig.curLang]['LEAST_DIGITS'];
            this.isSubmit();
            return false;
          }
        }
      },

      

      // 昵称输入
      nickNameChage(val){
        //this.isSubmitting = true;
        if(val == this.login.nickname && this.account.avatar == this.login.avatar){
          this.isEdit = true;
        }else{
          this.account.nickname = val;
          this.isEdit = false;
        }
        
      },
      nickNameBlur(){
        let that = this;
        // 当不是在提交表单时，触发blur事件才执行真正的处理逻辑
        // setTimeout(function(){
        //   if (!that.isSubmitting) {
        //     that.account.nickname = that.login.nickname;
        //     that.isEdit = true;
        //   }
        // }, 200);
        
      },

      beforeRead(file) {
        this.isUpload = true
        // 检查文件类型
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          Toast('Please upload images in JPG or PNG format.');
          this.isUpload = false
          return false;
        }

        // 检查文件大小
        if (file.size > 1024 * 1024) {
          Toast('Please upload an image smaller than 1MB.');
          this.isUpload = false
          return false;
        }

        if(file){
          const fd = new FormData();
          console.log('file', file)
          fd.append('file', file);
          fd.append("langNumber", 3);
          fd.append("platform", 4);
          fd.append("portType", 1);
          
          getAvatarUpload(fd).then(res =>{
            this.isUpload = false
            let _res = res;
            if(_res.state == 200){
              this.account.avatar = res.data.url;
              
              this.isEdit = false;
            }else{
              Toast(_res.msg);
            }
          }).catch((res) => {
            console.error(res)
          })
        }
      },
      
      // 滚动事件
      handleScroll() {
        let top = document.body.scrollTop || document.documentElement.scrollTop;
        if (top >= 100) {
          this.isScoll = true
        } else {
          this.isScoll = false
        }
      },

      // 头部样式
      headerStyle(){
        // if(this.pageType == 'poster' || this.pageType == 'details' || this.pageType == 'about'){
        if(this.pageType != ''){
          return 'header-bg';
        }
        return '';
      },

      headerLayoutStyle(){
        if(this.pageType == 'about'){
          return 'header-fixed'
        }
        return '';
      },

      // 
      noNavStyle(){
        if(this.pageType == 'details'){
          return true;
        }
        return false;
      },

      // google登录
      loginWithGoogle(){
        if(this.common.isWeiXin()){
          this.wxShow = true;
          return;
        }
        this.common.loginWithGoogle();
      },
    },
    beforeDestroy() {
      if(typeof(window) != 'undefined'){
        document.removeEventListener('click', this.bodyClose);
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);
      }
    },

    watch:{
      'tsz':{
        immediate:true,
        handler(val){
          //console.log('弹窗时区', val)
          if(val != 0){
            this.svrTimestamp = val;
          }
        }
      },
      'isLogin': {
        immediate:true,
        handler(val){
          //console.log('登录', val)
          this.loginShow = val;
        }

      }
    }
  }
</script>

<style lang="less" scoped>
@import '~@/style/header/header.less';
</style>


// WEBPACK FOOTER //
// ./src/components/header.vue